import { createApp } from "vue";
import App from "./App.vue";
import "./assets/tailwind.css";
import router from "./router";
import { createPinia } from "pinia";
import { createHead } from "@vueuse/head";

const app = createApp(App);

// ✅ Create and use Pinia first
const pinia = createPinia();
app.use(pinia);

// ✅ Head management for per-route SEO meta (title/description/OG/canonical)
app.use(createHead());

// ✅ Then use the router
app.use(router);

// ✅ Mount after the router has resolved the initial route, then signal the
// prerenderer that the page is ready to be snapshotted.
router.isReady().then(() => {
  app.mount("#app");
  document.dispatchEvent(new Event("render-event"));
});
